import { ReactElement } from 'react';
import { EditTextFieldModal } from './EditTextFieldModal';

interface RequirementExemptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (noteText: string) => void;
  initialNote?: string;
}

export const RequirementExemptModal = ({
  isOpen,
  onClose,
  onConfirm,
  initialNote = '',
}: RequirementExemptModalProps): ReactElement => {
  return (
    <EditTextFieldModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onConfirm}
      title="Requirement exempt"
      fieldLabel="Add an internal note (optional)"
      fieldSubLabel="Not shared with the applicant"
      confirmLabel="Confirm exemption"
      placeholder="Add note..."
      initialValue={initialNote}
    />
  );
};
